import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Heart } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card } from '../components/ui/card';

const RSVP = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#E5E1C7] via-[#D4B99D]/30 to-[#E5E1C7] flex items-center justify-center p-4">
      <Card className="max-w-xl w-full border-2 border-[#A16C56]/20 bg-white/95 backdrop-blur-md shadow-2xl p-12 text-center animate-in fade-in zoom-in duration-500">
        <div className="w-24 h-24 bg-red-50 rounded-full flex items-center justify-center mx-auto mb-8">
          <Heart className="w-12 h-12 text-[#A16C56] animate-pulse" />
        </div>
        <h2 className="text-4xl font-serif text-[#2A0306] mb-4">RSVP Closed</h2>
        <p className="text-xl text-[#2A0306]/70 mb-8 font-medium">
          rsvp cant be done. dates have passed.
        </p>
        <Button 
          onClick={() => navigate('/')}
          className="w-full bg-[#2A0306] hover:bg-[#2A0306]/90 text-[#E5E1C7] py-6 text-lg"
        >
          Return Home
        </Button>
      </Card>
    </div>
  );
};

export default RSVP;
